import { render, staticRenderFns } from "./csv-settings.vue?vue&type=template&id=3ae4f1fc&scoped=true"
import script from "./csv-settings.vue?vue&type=script&lang=js"
export * from "./csv-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae4f1fc",
  null
  
)

export default component.exports